module.exports = __webpack_public_path__ + "static/img/carousel_first.dc809e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AmongUs/carousel_first.png
// module id = Lxpf
// module chunks = 1